/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ViewRequirementFromJSON, ViewRequirementToJSON } from './ViewRequirement';

/**
 * Resource Handler that is registered
 * @export
 * @interface ResourceHandler
 */

/**
 * Check if a given object implements the ResourceHandler interface.
 */
export function instanceOfResourceHandler(value) {
  if (!('rid' in value) || value['rid'] === undefined) return false;
  if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
  if (!('handleWith' in value) || value['handleWith'] === undefined) return false;
  return true;
}
export function ResourceHandlerFromJSON(json) {
  return ResourceHandlerFromJSONTyped(json, false);
}
export function ResourceHandlerFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'rid': json['rid'],
    'containerRID': json['containerRID'] == null ? undefined : json['containerRID'],
    'resourceType': json['resourceType'],
    'handleWith': json['handleWith'],
    'requirements': json['requirements'] == null ? undefined : json['requirements'].map(ViewRequirementFromJSON)
  };
}
export function ResourceHandlerToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'rid': value['rid'],
    'containerRID': value['containerRID'],
    'resourceType': value['resourceType'],
    'handleWith': value['handleWith'],
    'requirements': value['requirements'] == null ? undefined : value['requirements'].map(ViewRequirementToJSON)
  };
}